<ion-range
  [min]="props.min"
  [max]="props.max"
  [formControl]="formControl"
  [ionFormlyAttributes]="field"
>
  <ion-label slot="start">{{ props.min }}</ion-label>
  <ion-label slot="end">{{ props.max }}</ion-label>
</ion-range>
